import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Clock, ArrowRight, Globe } from "lucide-react";
import { fill } from "@/lib/utils";
import { useLang } from "@/context/LangContext";
import { fmtTime } from "@/lib/prayerTimes";

// Today's six prayer times in a compact grid; the upcoming prayer is highlighted, past ones muted.
export function HomePrayerTimes({ times, nextKey, now, fallback, tz, tzHint }) {
  const { t } = useTranslation();
  const { tc, lang } = useLang();
  return (
    <div data-testid="home-prayer-times" data-next={nextKey || undefined}>
      <div className="mb-2 flex items-center justify-between gap-2">
        <p className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
          <Clock className="h-3.5 w-3.5" />{t("times")} · {tc({ id: "Hari ini", en: "Today", ar: "اليوم" })}{fallback ? ` · Makkah` : ""}
        </p>
        <Link to="/times" data-testid="home-prayer-times-link" className="inline-flex min-h-9 items-center gap-1 text-xs font-medium text-primary hover:underline">
          {tc({ id: "Lihat semua", en: "See all", ar: "عرض الكل" })} <ArrowRight className="h-3.5 w-3.5 rtl:-scale-x-100" />
        </Link>
      </div>
      <ul className="grid grid-cols-3 gap-1.5 sm:grid-cols-6">
        {times.map((p) => {
          const isNext = p.key === nextKey;
          const past = p.at <= now && !isNext;
          return (
            <li
              key={p.key}
              data-testid={`home-prayer-${p.key}`} data-next={isNext || undefined} data-past={past || undefined}
              className={`rounded-xl px-2 py-2 text-center transition-colors ${isNext ? "bg-primary text-white shadow-sm" : past ? "bg-secondary/40 text-muted-foreground/70" : "bg-secondary/70"}`}
            >
              <p className={`text-[11px] font-medium ${isNext ? "text-white/85" : "text-muted-foreground"}`}>{tc(p.label)}</p>
              <p className="font-serif text-base tabular-nums leading-tight">{fmtTime(p.at, lang, tz)}</p>
            </li>
          );
        })}
      </ul>
      {tzHint && (
        <p className="mt-2 inline-flex items-center gap-1.5 text-[11px] text-muted-foreground" data-testid="home-prayer-tz-hint" data-tz={tz}>
          <Globe className="h-3 w-3" />
          {fill(tc({ id: "Jam zona waktu lokasi ({tz}) · jam perangkat Anda {device}", en: "Clock in the location's time zone ({tz}) · your device is on {device}", ar: "التوقيت حسب المنطقة الزمنية للموقع ({tz}) · جهازك على {device}" }), { tz: tzHint.tzOffset, device: tzHint.deviceOffset })}
        </p>
      )}
    </div>
  );
}
